module.exports = __webpack_public_path__ + "img/50.8.TSS.dcd7d967.png";